{
	"tabs": {
		"discount": "Descontos",
		"menus": "Cardápios",
		"products": "Produtos",
		"vendorReport": "Relatório de vendors",
		"productReport": "Relatório por produto",
		"orderReport": "Relatório de pedidos",
		"config": "Configurações",
		"extract": "Extrato de vendor",
		"closings": "Fechamento por vendor",
		"productSoldByVendor": "Produtos vendidos por vendor",
		"vendorsRevenue": "Faturamento por vendor",
		"vendors": "Vendors",
		"invoicesIva": "Notas Fiscais",
		"invoicesNational": "Notas Fiscais",
		"invoicesBackups": "Backups",
		"missingInvoices": "Notas Faltantes",
		"missingInvoicesForeign": "Notas Pendentes",
		"trasactions": "Transações",
		"recharges": "Recargas",
		"notEmitedProducts": "Produtos não emitidos",
		"search": "Busca",
		"emited": "Emissões",
		"emissionErrors": "Erros de emissão",
		"fiscalReport": "Relatório fiscal",
		"debtorsReport": "Contas em Aberto"
	},
	"tooltips": {
		"soldProducts": "Total de produtos vendidos",
		"waiterReport": "Vendas por garçom",
		"entranceReport": "Entrada",
		"bonusByProductReport": "Bônus por produto",
		"closeCashier": "Fechamento de caixa",
		"soldEntrances": "Total de entradas vendidas",
		"minimumConsumptionReport": "Consumação antecipada",
		"cashierBalance": "Receita por caixa",
		"financialReport": "Fechamento",
		"vat": "O IVA está incluído no preço cadastrado do produto.",
		"netValue": "O Valor Líquido é calculado subtraindo o desconto e a porcentagem IVA do produto.",
		"invoiceValue": "Corresponde ao valor total da nota fiscal, essa pode incluir mais de 1 produto, portanto, mais de uma linha nessa tabela",
		"tipReport": "Relatório de Gorjeta"
	},
	"humanizedWithdrawType": {
		"anticipation": "Antecipação",
		"withdraw": "Saque",
		"withdrawAndAnticipation": "Saque com antecipação"
	},
	"humanizedWithdrawStatus": {
		"pending": "Pendente",
		"paid": "Pago",
		"refused": "Negado",
		"processing": "Em processamento"
	},
	"parsePaymentMethodV2": {
		"bonus": "Bônus",
		"cash": "Dinheiro",
		"creditCard": "Cartão de crédito",
		"debitCard": "Cartão de débito",
		"postEvent": "Pós evento",
		"voucher": "Voucher",
		"zigPosCredit": "Crédito integrado",
		"zigPosDebit": "Débito integrado",
		"pix": "Pix",
		"foodVoucher": "Vale-refeição",
		"ame": "Ame",
		"anticipated": "Antecipado",
		"zigPosCreditInInstallments": "Crédito parcelado",
		"rappi": "Rappi",
		"ifood": "Ifood",
		"uber": "Uber",
		"deliveryOnline": "Delivery Online",
		"dashboard": "Dashboard",
		"online": "Online",
		"cashless": "Cashless",
		"mbway": "MBWay",
		"total": "Total",
		"minimumConsumption": "Consumação antecipada",
		"app": "App",
		"digitalCashless": "Cashless digital",
		"unknown": "Desconhecido"
	},
	"defaultErrorMessage": "Ocorreu um erro com a sua solicitação",
	"xlsx": {
		"day": "{{title}} no dia {{date}}",
		"sinceUntil": "{{title}} entre {{since}} e {{until}}",
		"emissionInfo": "Documento emitido por {{currentEmployee}}, {{date}}",
		"data": "Dados",
		"zigEmissionDate": "ZIGPAY - Data de emissão {{date}}",
		"selectedPeriod": "período selecionado {{since}} até {{until}}"
	},
	"displayFiltersInfo": {
		"none": "Filtros: Sem filtros aplicados",
		"hasFilters": "Filtros: {{filters}}"
	}
}
